import { useEffect, useState, useCallback } from "react"
import { getStats, Loading, ECypherType, EHelpType, TCypher, TStats, TUser, Section, Select, Heading } from '@sifrovacihra/shared-ui'
import './stats.scss';
import { BiRefresh } from 'react-icons/bi';
import { actualYear, gameCathegoryByYear, gameIdByYear, previousYears } from "../../utils";
import { useAppState } from "../../store"
import { stats2023, stats2024Z, stats2024P, stats2025P, stats2025Z } from "../../resources";

type statsProps = {
    preselectedYear?: string
}

export const Stats = ({ preselectedYear}: statsProps) => {
    const [stats, setStats] = useState<TStats>()
    const [loading, setLoading] = useState(false)
    const [refreshVisible, setRefreshVisible] = useState(false)
    const [year, setYear] = useState(actualYear.id)
    const { state } = useAppState()

    const refresh = useCallback(() => {
        switch (year) {
            case "2023": return setStats(stats2023)
            case "2024Z": return setStats(stats2024Z)
            case "2024P": return setStats(stats2024P)
            case "2025Z": return setStats(stats2025Z)
            case "2025P": return setStats(stats2025P)
            default: {
                setLoading(true)
                getStats(
                    {
                        game: gameIdByYear(year),
                        cathegory: gameCathegoryByYear(year),
                        token: state?.token
                    }
                ).then(res => {
                    if (res.stats) {
                        setStats(res.stats)
                    }
                }).finally(() => setLoading(false))
            }
        }
    }, [state?.token, year])

    useEffect(() => {
        refresh()
        if (preselectedYear) {
            setYear(preselectedYear)
        }
    }, [preselectedYear, refresh])

    useEffect(() => {
        if (year.startsWith('2026')) {
            setRefreshVisible(true)
        } else {
            setRefreshVisible(false)
        }
        refresh()
    },[refresh, year])

    const FirstRow = () => {
        if (!stats) {
            return <></>
        } else {
            return (
                <div className='stats__first_row'>
                    <div className='stats__collumn_order'></div>
                    <div className='stats__collumn_team'></div>
                    {stats.cyphers.filter(c => c.type === ECypherType.CYPHER || c.type === ECypherType.START).map(c => <div className='stats__collumn_cypher_time'>{c.Id}</div>)}
                    <div className='stats__collumn_cypher_time'>Cíl</div>
                    <div className='stats__collumn_time'>Celkový čas</div>
                </div>
            )
        }
    }

    const getCypherTeamTime = (c: TCypher, t: TUser) =>  {
        const time = stats?.teamCyphers.find(tc => tc.id_cypher === c.Id && tc.id_team === t.Id)?.time
        if (time) {
            const date = new Date(time)
            return `${date.getHours()}:${date.getMinutes().toLocaleString('cs-CS', { minimumIntegerDigits: 2, useGrouping: false })}`
        } else return ''
    }

    const getHelpClass = (c: TCypher, t: TUser) => {
        const helps = stats?.teamHelps?.filter(h => h.id_team === t.Id && h.help.cypher === c.Id)
        const help = helps?.sort((a, b) => (a.help.order || 0) - (b.help.order || 0)).pop()
        switch (help?.help.type ) {
            case EHelpType.NORMAL: return 'help_normal'
            case EHelpType.INSTRUCTION: return 'help_instruction'
            case EHelpType.ABSOLUTE: return 'help_absolute'
            default: return ''
        }
    }


    const TeamRows = () => {
        if (!stats) {
            return <></>
        } else {
            return (
                <>
                    {stats?.teams.map(
                        (t, i) =>
                            <div className='stats__row'>
                                <div className='stats__collumn_order'>{`${i + 1}.`}</div>
                                <div className='stats__collumn_team'>{t.Name}</div>
                                {stats.cyphers.filter(c => c.type === ECypherType.START).map(c => <div className={`stats__collumn_cypher_time ${getHelpClass(c, t)}`}>{getCypherTeamTime(c, t)}</div>)}
                                {stats.cyphers.filter(c => c.type === ECypherType.CYPHER).map(c => <div className={`stats__collumn_cypher_time ${getHelpClass(c,t)}`}>{getCypherTeamTime(c, t) }</div> ) }
                                {stats.cyphers.filter(c => c.type === ECypherType.FINISH).map(c => <div className='stats__collumn_cypher_time'>{getCypherTeamTime(c, t)}</div>)}
                                <div className='stats__collumn_time'>{t.GameInfo?.totalTime.toString() || ''}</div>
                            </div>
                        )
                    }
                </>
            )
        }
    }

    const avaiableYears = () => {
        let years = [previousYears[2]]
        years.push(previousYears[3], previousYears[4])
        years.push(previousYears[5], previousYears[6])
        years.push(previousYears[7], previousYears[8])
        return years
    }

    return (
        <>
            <Heading headline='Průchod týmů' weight={1} />
            <Section centered={true}>
                <Select options={avaiableYears().map(y => ({ key: y.id, label: y.value }))} value={year} label="Zvolte ročník" onChange={setYear} />
            </Section>

            {
                refreshVisible ? 
                    <div className='refresh'>
                        {loading ? <Loading /> : <BiRefresh onClick={refresh} color='#ffcc00' size={50} />}
                    </div>
                : ''
            }
            
            <div className='stats'>
                <div className='stats__container'>
                    <FirstRow />
                    <TeamRows />
                </div>
            </div>
        </>
        )
} 
